/** Copy of "Pligter og rettigheder" for the quiz dashboard, the quiz tabs and the header menu on bidmio.dk. */
export const DA_RIGHTS_SITE_QUIZ = {
  title: 'Pligter og rettigheder for håndværkere',
  description:
    'Op til otte korte spørgsmål, og du ser kun det, der gælder for dig: moms, B-skat, digital bogføring, ansatte, aftaler med kunden og betaling. Hver regel med kilde.',
  short: 'Pligter og rettigheder',
  menuLabel: 'Hvilke pligter og rettigheder har du som håndværker?',
};
